import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { JoliooHistoryEntry } from "../../io/jolioo/voucher.types";
import { GetVoucherHistory } from "../../store/voucher/voucher.selector";

/**
 * Zeigt die Einlösungen eines Gutscheins. Das CMS reicht nur Zeitpunkt, Art und
 * Betrag durch — nie die Apotheke, in der eingelöst wurde.
 */
@Component({
  selector: "app-voucher-history",
  templateUrl: "./voucher-history.component.html",
  styleUrls: ["./voucher-history.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VoucherHistoryComponent {
  public history$: Observable<Array<JoliooHistoryEntry>>;

  constructor(private _store: Store) {
    this.history$ = this._store.select(GetVoucherHistory);
  }
}
